module.exports = __webpack_public_path__ + "static/media/vippsentrance.53f30439.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Signup/Media/vippsentrance.PNG
// module id = 251
// module chunks = 0